// Service worker registration + install prompt handling
export function registerServiceWorker() {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;

    window.addEventListener('load', () => {
        // Ricarica automaticamente quando un nuovo service worker prende il controllo
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
        });

        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
                // eslint-disable-next-line no-console
                console.log('SW registrato:', registration.scope);

                registration.addEventListener('updatefound', () => {
                    const installing = registration.installing;
                    if (!installing) return;
                    installing.addEventListener('statechange', () => {
                        if (
                            installing.state === 'installed' &&
                            navigator.serviceWorker.controller
                        ) {
                            // Nuova versione disponibile: attivala subito
                            installing.postMessage({ type: 'SKIP_WAITING' });
                            window.dispatchEvent(new Event('sw-update-available'));
                        }
                    });
                });
            })
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.warn('SW registration failed:', err);
            });
    });

    // Capture install prompt globally
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        window.__pwaInstallPrompt = e;
        window.dispatchEvent(new Event('pwa-install-available'));
    });

    window.addEventListener('appinstalled', () => {
        window.__pwaInstallPrompt = null;
        window.dispatchEvent(new Event('pwa-installed'));
    });
}
